const accessConfiguration = {
  'material-cost': {
    fieldJson: [],
    tableJson: [
      {
        prop: 'name',
        display: 'false'
      },
      {
        prop: 'spec',
        display: 'true'
      },
      {
        prop: 'unit',
        display: 'true'
      },
      {
        prop: 'net',
        display: 'false'
      },
      {
        prop: 'expendable-weight',
        display: 'false'
      },
      {
        prop: 'unitprice',
        display: 'false'
      },
      {
        prop: 'price',
        display: 'false'
      }
    ]
  },
  outsocring: {
    fieldJson: [],
    tableJson: [
      {
        prop: 'name',
        display: 'false'
      },
      {
        prop: 'spec',
        display: 'true'
      },
      {
        prop: 'unit',
        display: 'true'
      },
      {
        prop: 'net',
        display: 'false'
      },
      {
        prop: 'expendable-weight',
        display: 'false'
      },
      {
        prop: 'unitprice',
        display: 'false'
      },
      {
        prop: 'price',
        display: 'false'
      }
    ]
  },
  'machine-cost': {
    fieldJson: [],
    tableJson: [
      {
        prop: 'name',
        display: 'false'
      },
      {
        prop: 'spec',
        display: 'true'
      },
      {
        prop: 'unit',
        display: 'true'
      },
      {
        prop: 'net',
        display: 'false'
      },
      {
        prop: 'expendable-weight',
        display: 'false'
      },
      {
        prop: 'unitprice',
        display: 'false'
      },
      {
        prop: 'price',
        display: 'false'
      }
    ]
  }
};

export default accessConfiguration;
